import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ChartBar, Warning, CheckCircle, ChartLineUp } from "@phosphor-icons/react";

const $ = (cents) => `$${((cents || 0) / 100).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;

/**
 * Chip that renders next to any WO estimate. Fetches quote-confidence and
 * shows a color-coded percent + reason. Silent when the WO has no estimate.
 */
export default function QuoteConfidenceChip({ jobId, compact = false }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!jobId) return;
    api.get(`/quote-confidence/${jobId}`)
      .then(r => setData(r.data))
      .catch(() => setData(null));
  }, [jobId]);

  if (!data || data.confidence == null) return null;

  const c = data.confidence;
  const style = c >= 80 ? { bg: "bg-emerald-600", text: "text-emerald-700", label: "HIGH" }
              : c >= 60 ? { bg: "bg-amber-500",   text: "text-amber-700",   label: "OK" }
              : c >= 40 ? { bg: "bg-orange-500",  text: "text-orange-700",  label: "LOW" }
              :           { bg: "bg-red-600",     text: "text-red-700",     label: "REVIEW" };

  return (
    <div data-testid={`quote-confidence-${jobId}`}
      className="inline-flex items-stretch border-2 border-slate-900 shadow-[2px_2px_0_#0f172a]">
      <div className={`${style.bg} text-white px-2 flex flex-col items-center justify-center min-w-[52px]`}>
        <div className="font-display font-black text-xl leading-none">{c}%</div>
        <div className="text-[8px] font-black uppercase tracking-widest opacity-90">{style.label}</div>
      </div>
      {!compact && (
        <div className="bg-white px-2 py-1 min-w-0">
          <div className="text-[9px] font-black uppercase tracking-widest text-slate-500 flex items-center gap-1">
            <ChartLineUp weight="bold" size={10}/> Estimate Confidence
          </div>
          <div className={`text-[11px] font-bold ${style.text}`}>{data.reason}</div>
          {data.peer_avg_cents > 0 && (
            <div className="text-[10px] text-slate-500 mt-0.5">
              You: {$(data.estimate_cents)} · Peer avg: {$(data.peer_avg_cents)} · n={data.sample_size}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
